// extracted by mini-css-extract-plugin
export default {"quantity_container":"UJ","hiddenflavorstring":"VJ","loadingLine":"WJ","productimgwrap":"XJ","productimg":"YJ","circlepic":"ZJ","productinfo":"aK","grey_x":"bK","cartrow":"cK","bold":"eK","title":"fK","blue":"gK","strike":"hK","flexgap":"iK","flavorstring":"jK","nodecorate":"kK","flavorstring_link":"lK","rdstring":"mK","removeditemblock":"nK","removed_heading":"oK","removed_text":"pK","addback":"qK"};
    if(module.hot) {
      // 1715091679889
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  